import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const HighlightMark = styled.mark`
  padding: 0 1px;
  border-radius: 2px;
  background: ${Color.Yellow100};
  color: inherit;
`
